module.exports = __webpack_public_path__ + "static/img/right.2f00314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/right.png
// module id = rhN6
// module chunks = 1